module.exports = __webpack_public_path__ + "img/wide.2c5d2105.jpg";